import { createSlice } from "@reduxjs/toolkit";

const PusherSlice = createSlice({
    name: "pusher",
    initialState: {
        pusher_data: [],
    },
    reducers: {
        pusherReset: (state) => {
            state.pusher_data = []
        },
        pusherData: (state, action) => {
            state.pusher_data = action.payload;
        }
    }

})

export const {pusherReset, pusherData} = PusherSlice.actions
export default PusherSlice.reducer